import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";
import { mappingResultError, Result } from '@digibricks/domains';
import { LLM_PROVIDER_REPOSITORY } from '../../core';
import { LLM_PROVIDER_API } from '../data-sources';
export var LlmProviderWebRepository = /*#__PURE__*/function () {
  function LlmProviderWebRepository(llmProviderApi) {
    _classCallCheck(this, LlmProviderWebRepository);

    this.llmProviderApi = llmProviderApi;
  }

  _createClass(LlmProviderWebRepository, [{
    key: "getLlmProviders",
    value: function () {
      var _getLlmProviders = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(query) {
        var responseOrError;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.llmProviderApi.getLlmProviders(query);

              case 2:
                responseOrError = _context.sent;

                if (!responseOrError.isFailure) {
                  _context.next = 5;
                  break;
                }

                return _context.abrupt("return", mappingResultError(responseOrError));

              case 5:
                return _context.abrupt("return", Result.ok(responseOrError.getValue()));

              case 6:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getLlmProviders(_x) {
        return _getLlmProviders.apply(this, arguments);
      }

      return getLlmProviders;
    }()
  }]);

  return LlmProviderWebRepository;
}();
export var llmProviderWebRepositoryProvider = {
  provide: LLM_PROVIDER_REPOSITORY,
  useFactory: function useFactory(llmProviderApi) {
    return new LlmProviderWebRepository(llmProviderApi);
  },
  inject: [LLM_PROVIDER_API]
};